<template>
  <div>
    <span
      class="spinner-border text-primary"
      :class="{'spinner-border-sm': small}"
      role="status"
      aria-hidden="true"
    ></span>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    small: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
};
</script>
